import cx from "classnames"
import styles from "./Checkbox.module.scss"

const CheckboxField = ({ field, methods, className, inputClassName }) => {
  const { label, value, name, appearance } = field

  const { register } = methods

  const labelStyle = appearance || "default"

  return (
    <label
      className={cx(
        styles.label,
        {
          [styles.default]: labelStyle === "default",
          [styles.small]: labelStyle === "small",
        },
        className
      )}
    >
      <input
        className={cx(styles.input, inputClassName)}
        type="checkbox"
        value={value}
        {...register(name)}
      />
      <span dangerouslySetInnerHTML={{ __html: label }} />
    </label>
  )
}

export default CheckboxField
